module.exports = __webpack_public_path__ + "static/img/slogen.0808f72e.png";